import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable()
export class CookieAuthInterceptor implements HttpInterceptor {
	private excludedCredUrls = ['email_info', 'discovery', 'storage.googleapis.com', 'assets/'];

	constructor() {}

	private shouldAddCookieCredentials(url: string): boolean {
		// Don't add cookies for excluded URLs
		if (this.urlMatchesExceptions(url)) {
			return false;
		}

		return true;
	}

	private urlMatchesExceptions(url: string): boolean {
		return this.excludedCredUrls.some((exception) => url.includes(exception));
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		// Add cookie credentials only for non-excluded URLs
		const shouldAddCreds = this.shouldAddCookieCredentials(request.url);
		const newRequest = shouldAddCreds ? request.clone({ withCredentials: true }) : request;

		return next.handle(newRequest);
	}
}
